import { Container } from 'zimjs'

export abstract class AbstractContainer extends Container {}
